module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-29.f6a530d0.png";